export default "__VITE_ASSET__Bsk4bbka__"